<template>
  <div ref="printhtmlEVENT" id="printhtmlEVENT">
    <div>
      <div class="title">{{eventName}} {{date}}預約</div>
      <div class="summary">
        <div>總人數 : <span>{{total}}</span></div>
        <div>大人 : <span>{{totalA}}</span></div>
        <div>小孩 : <span>{{totalC}}</span></div>
      </div>
      <table>
        <tbody>
          <template v-for="({session, field_sn: fieldSn, status, visitDate, field_name, field_tel, reserveNum, reserveNumChild, salesman, field_remark}, i) in items">
            <tr :key="i"
            class="box" :class="[status==='已取消'?'canceled':'', status]">
            <td>{{status}}</td>
            <td>
              <div>{{moment(visitDate).format('yyyy/MM/DD')}}</div>
              <div>{{session}}</div>
            </td>
            <td>{{getSN(session, fieldSn)}}</td>
            <td>
              <div>預約人 : {{field_name}}</div>
              <div>聯絡電話 : {{field_tel}}</div>
            </td>
            <td>
              <span>{{reserveNum}}大</span>
              <span>{{reserveNumChild}}小</span>
            </td>
            <td>
              <div>業務</div>
              <div>{{salesman ? salesman.name : '-'}}</div>
            </td>
            <td>備註: {{field_remark}}</td>
          </tr>
          <tr class="box-btw" :key="`box-btw-${i}`"><td colspan="7"></td></tr>
        </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: ['print', 'items', 'eventName', 'date', 'sessions'],
  watch: {
    print () {
      if (this.print) {
        // console.log(print)
        this.printing()
      }
    }
  },
  computed: {
    total () {
      return this.items.filter(e => e.status !== '已取消').map(e => e.reserveNum + e.reserveNumChild).reduce((a, b) => a + b, 0)
    },
    totalA () {
      return this.items.filter(e => e.status !== '已取消').map(e => e.reserveNum).reduce((a, b) => a + b, 0)
    },
    totalC () {
      return this.items.filter(e => e.status !== '已取消').map(e => e.reserveNumChild).reduce((a, b) => a + b, 0)
    }
  },
  methods: {
    getSN (session, fieldSn) {
      const index = this.sessions.indexOf(session)
      return `${String.fromCharCode(65 + index)}${fieldSn[0].toString().padStart(3, 0)}`
    },
    printing () {
      const css = `
        @page {size: A4 portrait;}
        * {
          font-family: 'Roboto', 'Noto Sans TC';
        }
        body {
          padding: 0;
          margin: auto;
          -webkit-print-color-adjust:exact !important;
          print-color-adjust:exact !important;
        }
        #printhtmlEVENT {
          max-width: 866px;
          width: 866px;
          margin: auto;
          display: flex;
          flex-direction: column;
          background: #FFFFFF;
        }.title {
          font-weight: 400;
          font-size: 20px;
          line-height: 29px;
          text-align: center;
          color: #5E5E5E;
        }
        .summary {
          border: 1px solid #5e5e5e;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 64px;
          margin-top: 9px;
          height: 27px;
          font-weight: 400;
          font-size: 12px;
          line-height: 17px;
          color: #5E5E5E;
        }
        div {
          box-sizing: border-box;
        }
        table {
          margin-top: 18px;
          display:  table;
          width: 100%;
          border-collapse: collapse;
        }
        tbody {
          display: table-row-group;
          width: 100%;
        }
        .box-btw {
          height: 15px;
        }
        .box.canceled {
          background: #D9D9D9;
        }
        .box>td {
          box-sizing: border-box;
          font-family: "Noto Sans TC";
          font-style: normal;
          font-weight: 400;
          text-align: center;
          color: rgb(94, 94, 94);
          border-right: 1px solid #5E5E5E;
          height: 85px;
          justify-content: center;
          width: fit-content;
        }
        td:nth-child(1) { width: 60px; min-width: 60px; }
        td:nth-child(4) { width: 191px; min-width: 191px; }
        td:nth-child(5) { width: 112px; min-width: 112px; }
        td:nth-child(6) { width: 64px; min-width: 64px; }
        td:nth-child(7) { width: inherit; }
        td:nth-child(2) {
          flex-direction: column;
          text-align: center;
          width: 91px;
          min-width: 91px;
        }
        td:nth-child(3) {
          font-size: 20px;
          font-weight: 700;
          width: 82px;
          min-width: 82px;
        }
        td:nth-child(2)>div:nth-child(2) {
          font-size: 14px;
          font-weight: 900;
        }
        td:nth-child(4) {
          flex-direction: column;
          width: 200px;
          align-items: flex-start;
          padding-inline: 9px;
          text-align: start;
        }
        td:nth-child(6) {
          flex-direction: column;
          width: 70px;
          align-items: center;
        }
        td:nth-child(7) {
          text-align: start;
          padding-left: 9px;
          border-right: none;
        }
        .box {
          width: 100%;
          display: table-row;
          font-family: "Noto Sans TC";
          font-style: normal;
          font-weight: 400;
          text-align: center;
          color: rgb(94, 94, 94);
          margin-block: 15px;
          height: 85px;
          border-radius: 3px;
          border: 1px solid #5E5E5E!important;
        }
      `

      const content = document.getElementById('printhtmlEVENT')
      const ht = document.createElement('html')
      const head = document.createElement('head')
      const body = document.createElement('body')
      const title = document.createElement('title')
      title.innerText = `${this.eventName}-${this.date}`
      const div = document.createElement('div')
      div.id = 'printhtmlEVENT'
      div.innerHTML = content.innerHTML

      body.appendChild(div)
      head.appendChild(title)
      const style = document.createElement('style')
      style.type = 'text/css'
      style.media = 'print'
      style.appendChild(document.createTextNode(css))
      const style1 = document.createElement('style')
      style1.type = 'text/css'
      style1.media = 'screen'
      style1.appendChild(document.createTextNode(css))
      head.appendChild(style)
      head.appendChild(style1)
      ht.appendChild(head)
      ht.appendChild(body)
      const printWin = window.open('', '', '')
      printWin.document.write(`<html>${ht.innerHTML}</html>`)
      printWin.document.close()
      setTimeout(() => {
        printWin.print()
      }, 500)
      this.$emit('printed')
      return false
    }
  }

}
</script>

<style lang="scss">
@media print {
  div {
    box-sizing: border-box;
  }
}
</style>
<style lang="scss" scoped>
#printhtmlEVENT {
  // border: 1px solid red;
  box-sizing: border-box;
  height: 100%;
  // background-color: #FDFFF2;
  .title {
    font-weight: 400;
    font-size: 20px;
    line-height: 29px;
    text-align: center;
    color: #5E5E5E;

  }
  .summary {
    border: 1px solid #5e5e5e;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 64px;
    margin-top: 9px;
    height: 27px;
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    color: #5E5E5E;
  }
  div {
    box-sizing: border-box;
  }
  table {
    margin-top: 18px;
    display:  table;
    border-collapse: collapse;
  }
  tbody {
    display: table-row-group;
  }
  .box {
    display: table-row;
    font-family: "Noto Sans TC";
    font-style: normal;
    font-weight: 400;
    text-align: center;
    color: rgb(94, 94, 94);
    border: 1px solid #5E5E5E;
    margin-block: 15px;
    height: 85px;
    border-radius: 3px;
  }
  .box-btw {
    height: 15px;
  }
  .box.canceled {
    background: #D9D9D9;
  }
  .box>td {
    box-sizing: border-box;
    font-family: "Noto Sans TC";
    font-style: normal;
    font-weight: 400;
    text-align: center;
    color: rgb(94, 94, 94);
    border-right: 1px solid #5E5E5E;
    height: 85px;
    justify-content: center;
    width: fit-content;
  }
  td:nth-child(1) { width: 60px; min-width: 60px; }
  td:nth-child(4) { width: 191px; min-width: 191px; }
  td:nth-child(5) { width: 112px; min-width: 112px; }
  td:nth-child(6) { width: 64px; min-width: 64px; }
  td:nth-child(7) { width: inherit; }
  td:nth-child(2) {
    flex-direction: column;
    text-align: center;
    width: 91px;
    min-width: 91px;
  }
  td:nth-child(3) {
    font-size: 20px;
    font-weight: 700;
    width: 82px;
    min-width: 82px;
  }
  td:nth-child(2)>div:nth-child(2) {
    font-size: 14px;
    font-weight: 900;
  }
  td:nth-child(4) {
    flex-direction: column;
    width: 200px;
    align-items: flex-start;
    padding-inline: 9px;
    text-align: start;
  }
  td:nth-child(6) {
    flex-direction: column;
    width: 70px;
    align-items: center;
  }
  td:nth-child(7) {
    text-align: start;
    padding-left: 9px;
  }
}
</style>
